import { render, staticRenderFns } from "./Indicator.vue?vue&type=template&id=160b70bc&scoped=true&"
import script from "./Indicator.vue?vue&type=script&lang=js&"
export * from "./Indicator.vue?vue&type=script&lang=js&"
import style0 from "./Indicator.vue?vue&type=style&index=0&id=160b70bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b70bc",
  null
  
)

export default component.exports